export const CHANGE_COURSELIVE_DATA = 'courselive/CHANGE_COURSELIVE_DATA';
export const CHANGE_COURSELIVE_LIST_DATA = 'courselive/CHANGE_COURSELIVE_LIST_DATA';
export const CHANGE_TOPIC_LIST = 'courselive/CHANGE_TOPIC_LIST';
export const CHANGE_TOPIC_CHAT_LIST = 'courselive/CHANGE_TOPIC_CHAT_LIST';
export const CHANGE_ATTACHMENT_LIST = 'courselive/CHANGE_ATTACHMENT_LIST';
export const CHANGE_TOPIC_ID = 'courselive/CHANGE_TOPIC_ID';
export const CHANGE_TOPIC_NEW_DATA = 'courselive/CHANGE_TOPIC_NEW_DATA';
export const CHANGE_COLLECT = 'courselive/CHANGE_COLLECT';

 